









import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';

/**
 * Composant de loading.
 */
@Component
export default class Loading extends Vue {
	/** Propriétés */
	@Prop({ default: 64 }) size!: number;
}
